import api from './index'
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
const baseurl = sysInfo.apiLocal
// export function getOAAuthorize () {
//   return axios({
//     url: sysInfo.apiOARemote + '/sso/oauth2.0/authorize',
//     method: 'GET',
//     params: sysInfo.authorizeParams
//   })
// }
// 登录
export function login (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/auth/login',
    method: 'POST',
    params: parameter
  })
}
export function logout () {
  return axios({
    url: sysInfo.apiRemote + '/auth/logout',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getSmsCaptcha (parameter) {
  return axios({
    url: baseurl + api.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo () {
  return axios({
    // url: baseurl + '/user/info.json',
    url: sysInfo.apiRemote + '/auth/info',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step (parameter) {
  return axios({
    url: api.twoStepCode,
    method: 'post',
    data: parameter
  })
}
